import http from "../httpService";
import {getBaseUrl} from "../../config";


export const submitAdminServiceSendPaymentLink = data => {
  return http.post(
    `${getBaseUrl()}/admin_service_send_payment_link`,
    data
  );
};
